import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { createCheckoutSession } from '@/features/subscriptions/api/create-checkout-session';
import { ORG_SUBSCRIPTION_QUERY_KEY } from '@/features/subscriptions/hooks/use-org-subscription';
import { toast } from '@/shared/hooks/use-toast';

export function useCreateCheckoutSession() {
  const queryClient = useQueryClient();
  const { t } = useTranslation('subscriptions');

  return useMutation({
    mutationFn: createCheckoutSession,
    onSuccess: async (data) => {
      if (data.type === 'subscription-updated') {
        // Subscription was updated directly (upgrade/downgrade)
        toast({
          title: t('messages.subscription_updated'),
          description: t('messages.subscription_updated_description'),
        });
        // Invalidate subscription query to refresh UI
        queryClient.invalidateQueries({
          queryKey: [ORG_SUBSCRIPTION_QUERY_KEY],
        });
        // webhook might take a moment to update in supabase
        await new Promise((resolve) => setTimeout(resolve, 2000));
        queryClient.invalidateQueries({
          queryKey: [ORG_SUBSCRIPTION_QUERY_KEY],
        });
      } else {
        // Redirect to Stripe Checkout for new subscription
        window.location.href = data.checkoutUrl;
      }
    },
  });
}
